import { PaymentProcessorAccountConfigurationBase } from '../payment-processor-account-configuration-base';

export class SquarePaymentProcessorAccountConfiguration extends PaymentProcessorAccountConfigurationBase {
  accessToken: string;
  locationId: string;

  constructor(options?: Partial<SquarePaymentProcessorAccountConfiguration>) {
    super(options);
  }
}
